import PlainHelperText from 'app/common/ui-next/plain-helper-text/plain-helper-text'
import { getScrollToErrorClassName } from 'app/common/hooks/useScrollToError'
import { ChangeEvent, useCallback, useState } from 'react'
import PlainRadioButton from 'app/common/ui-next/plain-radio-button'
import { FormTemplate } from './FormGridTemplate'
import styles from './AccrualPeriodFormCompensation.module.scss'

export const controls = {
  accrualPeriod: 'accrualPeriod'
}
export const selection = {
  month: 'month',
  quarter: 'quarter',
} as const

type Props = {
  accrualPeriod: string
  disabled?: boolean
  formID: string
  errors: Map<string, string>
  resetErrors: () => void
}

export const AccrualPeriodFormCompensation = ({ accrualPeriod, disabled, formID, errors, resetErrors }: Props) => {
  const error = errors.get(controls.accrualPeriod)
  const [curValue, setData] = useState<string>(accrualPeriod)

  const handleSelect = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const { value: val } = e.target
    if (val === 'month' || val === 'quarter') {
      setData(val)
      resetErrors()
    }
  }, [resetErrors])

  return (
    <>
      <FormTemplate
        title="Период начисления:"
      >
        <div className={styles.row}>
          <PlainRadioButton
            label={'ежемесячно'}
            name={controls.accrualPeriod}
            value={selection.month}
            checked={curValue === selection.month}
            onChange={handleSelect}
            disabled={disabled}
            form={formID}
          />
          <PlainRadioButton
            label={'ежеквартально'}
            name={controls.accrualPeriod}
            value={selection.quarter}
            checked={curValue === selection.quarter}
            onChange={handleSelect}
            disabled={disabled}
            form={formID}
          />
        </div>
      </FormTemplate>
      <PlainHelperText
        className={getScrollToErrorClassName(!!error)}
        error
      >
        {error}
      </PlainHelperText>
    </>
  )
}
